import { useCallback } from 'react';
import { DecisionPayload, submitDecision } from '../utils/curationApi';
import { useCurationReview } from './CurationReviewContext';

// Shared submit routine for both decision points (gate reject and the final
// panel). Posts to the decision endpoint, marks the review submitted and
// returns whether it succeeded; server-side errors land in submitError.
export const useSubmitDecision = () => {
  const { dispatch, state, urls } = useCurationReview();

  return useCallback(
    async (payload: Omit<DecisionPayload, 'handpicked' | 'notes' | 'force_general_list'> &
      Partial<Pick<DecisionPayload, 'handpicked' | 'notes' | 'force_general_list'>>) => {
      dispatch({ type: 'SUBMIT_START' });
      try {
        await submitDecision(urls, {
          force_general_list: false,
          handpicked: state.handpicked,
          notes: state.notes,
          ...payload,
        });
        dispatch({ type: 'SUBMITTED' });
        return true;
      } catch (error) {
        const body = (error as { body?: { errors?: { message?: string }[]; error?: string } }).body;
        const message =
          (body && body.errors && body.errors[0] && body.errors[0].message) ||
          (body && body.error) ||
          'The decision could not be submitted. Try again.';
        dispatch({ error: message, type: 'SUBMIT_FAILED' });
        return false;
      }
    },
    [dispatch, state.handpicked, state.notes, urls],
  );
};
